/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_link_minecraft_expires_in = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ticket expires in ${i?.minutes} minutes`)
};

const zh_hans1_link_minecraft_expires_in = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`凭证将在 ${i?.minutes} 分钟后过期`)
};

const zh_hant1_link_minecraft_expires_in = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`憑證將在 ${i?.minutes} 分鐘後過期`)
};

const fr_link_minecraft_expires_in = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le ticket expire dans ${i?.minutes} minutes`)
};

const de_link_minecraft_expires_in = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ticket läuft in ${i?.minutes} Minuten ab`)
};

const ja_link_minecraft_expires_in = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`チケットの有効期限は残り ${i?.minutes} 分です`)
};

const ko_link_minecraft_expires_in = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`티켓 유효기간이 ${i?.minutes}분 남았습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ minutes: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const link_minecraft_expires_in = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.link_minecraft_expires_in(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("link_minecraft_expires_in", locale)
	if (locale === "en") return en_link_minecraft_expires_in(inputs)
	if (locale === "zh-Hans") return zh_hans1_link_minecraft_expires_in(inputs)
	if (locale === "zh-Hant") return zh_hant1_link_minecraft_expires_in(inputs)
	if (locale === "fr") return fr_link_minecraft_expires_in(inputs)
	if (locale === "de") return de_link_minecraft_expires_in(inputs)
	if (locale === "ja") return ja_link_minecraft_expires_in(inputs)
	return ko_link_minecraft_expires_in(inputs)
};